module.exports = __webpack_public_path__ + "static/media/PushtimargImage40.bbb8f11e.jpg";